//支付配置
const WeixinAPIConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/weixinAPIConfigure.vue') //微信

const AlipayAPIConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/alipayAPIConfigure.vue') //支付宝

const XinjiangUnionPayNosenseConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/xinjiangUnionPayNosenseConfigure.vue') //新疆银联

const XinjiangUnionPayUnionConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/xinjiangUnionPayUnionConfigure.vue') //新疆银联

const CcbUnionConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/ccbUnionConfigure.vue') //建行

const NingxiaUnionPayUnionConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/ningxiaUnionPayUnionConfigure.vue') //宁夏银联

const BocConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/bocConfigure.vue') //中国银行

const AbcConfigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/abcConfigure.vue') //农业银行

const Invoicefigure = () => import(/*webpackChunkName:'operation'*/'@/page/operation/payConfigure/invoiceConfigure.vue') //发票配置


const RouteTemp = () => import(/*webpackChunkName:'operation'*/'@/page/commons/routeTemp.vue')

export const payConfigure =

    {
        path: '/main/payConfigure',
        name: '支付管理',
        component: RouteTemp,
        meta: {
            requireAuth: true,
        },
        children: [{
                path: '/main/payConfigure/weixinAPIConfigure',
                name: '微信配置',
                meta: {
                    requireAuth: true,
                },
                component: WeixinAPIConfigure
            },
            {
                path: '/main/payConfigure/alipayAPIConfigure',
                name: '支付宝配置',
                meta: {
                    requireAuth: true,
                },
                component: AlipayAPIConfigure
            },
            {
                path: '/main/payConfigure/xinjiangUnionPayUnionConfigure',
                name: '银联聚合配置',
                meta: {
                    requireAuth: true,
                },
                component: XinjiangUnionPayUnionConfigure
            },
            {
                path: '/main/payConfigure/xinjiangUnionPayNosenseConfigure',
                name: '银联无感配置',
                meta: {
                    requireAuth: true,
                },
                component: XinjiangUnionPayNosenseConfigure
            }, {
                path: '/main/payConfigure/ccbUnionConfigure',
                name: '建行配置',
                meta: {
                    requireAuth: true,
                },
                component: CcbUnionConfigure
            },
            {
                path: '/main/payConfigure/ningxiaUnionPayUnionConfigure',
                name: 'ATO主扫配置',
                meta: {
                    requireAuth: true,
                },
                component: NingxiaUnionPayUnionConfigure
            }, {
                path: '/main/payConfigure/bocConfigure',
                name: '中行配置',
                meta: {
                    requireAuth: true,
                },
                component: BocConfigure
            }, {
                path: '/main/payConfigure/abcConfigure',
                name: '农行无感配置',
                meta: {
                    requireAuth: true,
                },
                component: AbcConfigure
            },
            {
                path: '/main/payConfigure/invoicefigure',
                name: '电子发票配置',
                meta: {
                    requireAuth: true,
                },
                component: Invoicefigure
            }
        ]
    }